import { useCallback, useEffect, useState } from "react";

interface BrowserLocationSnapshot {
    pathname: string;
    search: string;
}

function readBrowserLocation(): BrowserLocationSnapshot {
    if (typeof window === "undefined") return { pathname: "/", search: "" };
    return {
        pathname: window.location.pathname,
        search: window.location.search
    };
}

export function useBrowserLocationSnapshot() {
    const [snapshot, setSnapshot] = useState(readBrowserLocation);
    const syncFromWindow = useCallback(() => {
        setSnapshot(readBrowserLocation());
    }, []);

    useEffect(() => {
        window.addEventListener("popstate", syncFromWindow);
        return () => window.removeEventListener("popstate", syncFromWindow);
    }, [syncFromWindow]);

    return {
        ...snapshot,
        syncFromWindow
    };
}
